import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DataService } from '../data/data.service';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';

@Injectable({ providedIn: 'root' })
export class CashBoxOpenedGuard {
  constructor(@Inject(SCREEN_LAYOUT) private readonly screenLayout: ScreenLayout,
              private readonly dataService: DataService,
              private readonly router: Router) {
  }

  canActivate(_: ActivatedRouteSnapshot, snapshot: RouterStateSnapshot): boolean | UrlTree {
    if (!this.dataService.cashBoxClosed) {
      return true;
    }

    // On mobile devices cash-box screen is displayed on separate page
    if (this.screenLayout === ScreenLayout.mobile) {
      return this.router.parseUrl('/cash-box/closed');
    }

    // On desktop cash-box is displayed on main screen's sidebar
    if (snapshot.url === '/') {
      return true;
    }

    return this.router.parseUrl('/');
  }
}
